import React from 'react';
import PropTypes from 'prop-types';
import style from '../style.module.scss';

export function Tooltip(props) {
  return (
    <div className={style.tooltip} style={props.tooltipStyle}>
      <p>
        {props.value}
        {` ${props.unit}`}
      </p>
    </div>
  );
}

Tooltip.propTypes = {
  /**
   * The unit for the value
   */
  unit: PropTypes.string,
  /**
   * Current value
   */
  value: PropTypes.number,
  /**
   * Style to apply on tooltip
   *  - Position left value
   */
  tooltipStyle: PropTypes.object,
};
